import { Box, CircularProgress } from "@mui/material";

export default function AppProgress({ minHeight }) {
    return (
        <Box
            sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                ...(minHeight ? { minHeight } : {}),
            }}
        >
            <CircularProgress />
        </Box>
    );
}
